const PropTypes = require('prop-types')
const isLoggedIn = require('module/viewer/helpers/is_logged_in')

// component which renders children if the viewer is logged in
function LoggedInComponent({ children }, { viewer }) {
    if (! isLoggedIn(viewer)) return null
    return children
}
LoggedInComponent.propTypes = {
    children: PropTypes.any,
}
LoggedInComponent.contextTypes = {
    viewer: PropTypes.object.isRequired,
}

module.exports = {
    LoggedInComponent,
}
